import localforage from 'localforage';
import { isObject } from 'lodash/fp';
import { CREATE_EXPLORATION_OPERATION } from 'app/store/__generated__/operations';
import { CREATE_QUERY } from './types.js';

export async function migrateExploreData(store) {
    const exploreData = await localforage.getItem('exploreData');

    if (!isObject(exploreData)) {
        return;
    }

    const { byEntityId, ...others } = exploreData;

    if (!isObject(byEntityId)) {
        return;
    }

    const queriesToMigrate = [];

    for (const entityId in byEntityId) {
        const queriesById = byEntityId[entityId];
        for (const queryUuid in queriesById) {
            const query = queriesById[queryUuid];
            const model = {
                version: query.version,
                queryUuid: query.queryUuid,
                index: query.index,
                filters: query.filters,
                sorts: query.sorts,
                dimensions: query.dimensions,
                measures: query.measures
            };

            queriesToMigrate.push({
                id: queryUuid,
                model: JSON.stringify(model),
                sql: query.sql,
                transformationId: entityId
            });
        }
    }

    try {
        await localforage.setItem('exploreData', others);
    } catch {
        console.error('[Migrate] Unable to update IndexDB entry for exploration data.');
    }

    for (const params of queriesToMigrate) {
        store.dispatch({
            type: CREATE_QUERY,
            api: CREATE_EXPLORATION_OPERATION,
            params
        });
    }
}
